import { Switch } from "@chakra-ui/react";
import i18next from "i18next";
import { TextAreaAttributeFilter } from "../../../../../map/models/MapFilters";

interface Props {
  setValue: (value: any) => void;
  attributeFilter: TextAreaAttributeFilter;
}

export const TextAreaFilter: React.FC<Props> = ({
  setValue,
  attributeFilter,
}) => {
  return (
    <Switch.Root
      mb={3}
      onCheckedChange={({ checked }) => {
        setValue({ value: checked });
      }}
      checked={attributeFilter.value}
      colorPalette={"primary"}
    >
      <Switch.HiddenInput />
      <Switch.Control />
      <Switch.Label>{i18next.t(`map:filters.textAreaLabel`)}</Switch.Label>
    </Switch.Root>
  );
};
